
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ubbm_1n37v_9",
  "hints": "awsui_hints_1ubbm_1n37v_10"
};
  